<template>
    <div class="dashboard-screen-page h-100">
        <transition name="loading-screen">
            <loading-screen v-if="loading"/>
        </transition>
        <div class="dashboard-infobox text-center p-4" v-if="!screen && rootAbsolutePath">
            <div class="float-left mt-1 mb-1 mr-3">
                <img :src="brandNavbarLogo" :alt="brandName" class="brandImageLogo" />
            </div>
            <div class="text-center text-white">
                <div class="h5">
                    C'est tout bon 👍🏻, écran connecté à Cérès.
                </div>
                <div class="h6">
                    Contactez un admin pour configurer l'affichage.
                </div>
                <div class="mt-2 mb-0 h6">
                    Code écran : {{ screenUid }}
                </div>
            </div>
        </div>
        <div class="dashboard-default d-flex flex-column align-items-center justify-content-center h-100" v-if="!dashboardComponent && rootAbsolutePath">
            <img :src="brandNavbarLogo" :alt="brandName" class="brandImageLogo">
            <h1 class="text-center mt-4 text-white">Chargement en cours...</h1>
            <span class="text-center mt-4 text-white">Code écran : {{ screenUid }}</span>
        </div>
        <component v-bind:is="dashboardComponent" v-if="dashboardComponent" :screenUid="screenUid" :screen="screen"></component>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";

    import {useGetLoader} from "../compositions/axios/loadingRequest";

    export default {
        name: 'DashboardScreenPage',

        components: {
            'errors-zone': ErrorsZone,
            'loading-screen': LoadingScreen,
        },

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            silent: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                loadedOnce: false,
                scrollInterval: null,
                screen: null,
                dashboardComponent: null,
            }
        },

        created() {
            Echo.channel(`dashboards`).listen('ScreenUpdatedEvent', (e) => {
                if (e.screen.uid === this.screenUid) {
                    this.loadStateFromServer();
                    if (e.reload) {
                        window.location.reload();
                    }
                }
            });
            Echo.channel(`dashboards`).listen('ScreenPingReportEvent', (e) => {
                this.loadDataFromServer();
            });
        },

        async mounted() {
            await this.loadStateFromServer();
        },

        methods: {
            async loadDataFromServer() {
                return await this.load(`/dashboards/screen/${this.screenUid}/json?silent=${this.silent ? 'true' : 'false'}`);
            },
            async loadStateFromServer() {
                const data = await this.load(`/dashboards/screen/${this.screenUid}/json?silent=${this.silent ? 'true' : 'false'}`);

                this.dashboardComponent = null;
                this.$nextTick(() => {
                    this.screen = null;
                    this.dashboardComponent = 'DashboardNoDashboard';
                    if (data && data.dashboardComponent) {
                        this.screen = data;
                        this.dashboardComponent = data.dashboardComponent;
                    }
                    clearInterval(this.scrollInterval);
                    this.pageScroll();
                    this.loadedOnce = true;
                });
            },
            pageScroll: function() {
                var retry = 0;
                var maxRetry = 30;
                var direction = 1;
                this.scrollInterval = global.setInterval(() => {
                    var originalScroll = window.scrollY;
                    global.scrollBy(0, direction);
                    if(originalScroll === window.scrollY) {
                        retry++;
                    } else {
                        retry = 0;
                    }
                    if (retry >= maxRetry) {
                        if(direction >= 0) {
                            direction = -1;
                        } else {
                            direction = 1;
                        }
                        retry = 0;
                    }
                }, 25)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-screen-page {
        .dashboard-default {
            background-color: black;
        }

        .brandImageLogo {
            max-height: 150px;
            max-width: 250px;
        }
        .dashboard-infobox {
            position: fixed;
            top: 40px;
            right: 0;
            min-width: 650px;
            background-color: #402916;
            font-size: 13px;
            line-height: 13px;
            color: white;
            z-index: 100;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            .brandImageLogo {
                max-height: 70px;
                max-width: 160px;
            }
        }
    }
</style>
